module.exports = __webpack_public_path__ + "img/5.ac250fc4.png";